import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withModifiers as _withModifiers, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "bg-yellow-200 m-8 rounded-xl shadow-lg p-6 flex flex-col items-center relative" }
const _hoisted_2 = { class: "text-2xl font-semibold" }
const _hoisted_3 = { class: "mt-2" }
const _hoisted_4 = { class: "signup-form flex flex-col items-center mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_selector = _resolveComponent("the-selector")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString($data.authHeader), 1),
    _createElementVNode("div", _hoisted_3, [
      _createTextVNode(_toDisplayString($data.headerText) + " ", 1),
      _createElementVNode("span", {
        class: "text-blue-700 cursor-pointer",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($data.authMode === 'signin' ? $options.switchToSignup() : $options.switchToSignin()))
      }, _toDisplayString($data.alternativeOperation), 1)
    ]),
    _createElementVNode("form", _hoisted_4, [
      ($data.authMode === 'signup')
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 0,
            class: "w-auto p-4 rounded-xl shadow outline-none mb-4",
            type: "text",
            placeholder: "Full Name",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ($data.name = $event)),
            required: ""
          }, null, 512)), [
            [_vModelText, $data.name]
          ])
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("input", {
        class: "w-auto p-4 rounded-xl shadow outline-none mb-4",
        type: "email",
        placeholder: "Email Address",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ($data.email = $event)),
        required: ""
      }, null, 512), [
        [_vModelText, $data.email]
      ]),
      _withDirectives(_createElementVNode("input", {
        class: "w-auto p-4 rounded-xl shadow outline-none mb-4",
        type: "password",
        placeholder: "Password",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ($data.password = $event)),
        required: ""
      }, null, 512), [
        [_vModelText, $data.password]
      ]),
      ($data.authMode === 'signup')
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 1,
            class: "w-auto p-4 rounded-xl shadow outline-none mb-4",
            type: "text",
            placeholder: "University ID",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ($data.uniId = $event)),
            required: ""
          }, null, 512)), [
            [_vModelText, $data.uniId]
          ])
        : _createCommentVNode("", true),
      ($data.authMode === 'signup')
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 2,
            class: "w-auto p-4 rounded-xl shadow outline-none mb-4",
            type: "text",
            placeholder: "Bio (optional)",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ($data.bio = $event))
          }, null, 512)), [
            [_vModelText, $data.bio]
          ])
        : _createCommentVNode("", true),
      ($data.authMode === 'signup')
        ? (_openBlock(), _createBlock(_component_the_selector, {
            key: 3,
            values: ['Communication', 'CompCommunication'],
            label: 'Department',
            class: "w-full -mt-1",
            defaultChoice: 'Communication',
            onCurrentValueChange: $options.syncDepartment
          }, null, 8, ["onCurrentValueChange"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, _toDisplayString($data.authResponse), 1),
      _createVNode(_component_the_button, {
        content: $data.submitBtnContent,
        size: "large",
        type: "primary",
        onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => ($data.authMode === 'signin' ? $options.signin() : $options.createAccount()), ["prevent"]))
      }, null, 8, ["content"])
    ])
  ]))
}